module.exports = __webpack_public_path__ + "img/register-email.7f22b76b.png";